import { chartEmptyValueConstants } from '../chartEmptyValueConstants';

const emptyKeyMap = {
  rejection_by_stage: 'rejected_milestone',
  rejection_by_source: 'appl_contact_source',
};

/**
 * Transforms interview data for feedback and duration charts
 * @param response API response data
 * @param feedbackKeys keys for feedback metrics
 * @returns Object containing data for both charts
 */
export const rejectionsVisualsTransformer = ({ response, metadata }) => {
  const { table = [], lookups: { g1 = {}, g1_l2 = [] } = {} } = response || {};

  const { tileKey } = metadata || {};
  const emptyKey = emptyKeyMap[tileKey];

  const formattedData = table?.map((curr) => {
    const group = curr[2];
    const value = curr[4];

    if (Array.isArray(g1[group])) {
      const nameLookup = g1?.[group]?.map((g1) => g1_l2[g1]?.name);
      return { value, name: nameLookup?.join(',') };
    }

    if (typeof g1[group] === 'object') {
      return { value, ...g1[group] };
    }
    return { value, key: g1[group] };
  }, []);

  // made changes to the series and categories to match the format of other charts
  const series = [];
  const categories = [];
  formattedData?.forEach((x) => {
    const originalName =
      x?.name || chartEmptyValueConstants[emptyKey] || 'Not found';

    // Map specific names to their new values
    let displayName = originalName;
    if (originalName === 'Lead') {
      displayName = 'Prospect';
    } else if (originalName === 'Applied') {
      displayName = 'Application Review';
    }

    series.push({
      name: displayName,
      y: x?.value,
      g1: x?.id || null,
    });
    categories.push(displayName);
  });

  return {
    series,
    categories,
  };
};
